import React, { JSX } from 'react';
import {
  Box,
  CircularProgress,
  IconButton,
  InputAdornment,
  LinearProgress,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { getPasswordStrength } from './registrationValidation';

export function PasswordField(props: {
  label: string;
  value: string;
  error?: string;
  placeholder: string;
  showPassword: boolean;
  showStrength?: boolean;
  onToggle: () => void;
  onChange: (value: string) => void;
}): JSX.Element {
  const strength = props.value ? getPasswordStrength(props.value) : null;

  return (
    <Box>
      <TextField
        fullWidth
        label={props.label}
        type={props.showPassword ? 'text' : 'password'}
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        placeholder={props.placeholder}
        error={!!props.error}
        helperText={props.error}
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label={`toggle ${props.label.toLowerCase()} visibility`}
                onClick={props.onToggle}
                onMouseDown={e => e.preventDefault()}
                edge="end"
              >
                {props.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      {props.showStrength && strength && (
        <Box sx={{ mt: 1 }}>
          <LinearProgress
            variant="determinate"
            value={strength.value}
            color={strength.color}
            sx={{ height: 6, borderRadius: 3 }}
          />
          <Typography
            variant="caption"
            color={`${strength.color}.main`}
            sx={{ mt: 0.5, display: 'block', textTransform: 'capitalize' }}
          >
            Password strength: {strength.level}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export function LoadingLabel(props: { text: string }): JSX.Element {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <CircularProgress size={20} color="inherit" />
      <Typography>{props.text}</Typography>
    </Stack>
  );
}
